// platform-password-recovery: /login/forgot?return= — "שכחתי סיסמה". אימייל → POST /auth/v1/recover ישירות ל-GoTrue (nginx /auth/v1/).
// התשובה למשתמש קבועה ("אם הכתובת רשומה…") בלי תלות בקיום המשתמש, במצבו, או בהצלחת ה-SMTP — אותו כרטיס, אותו טקסט, אותו
// data-testid. רק 429 (מייל אחד לכתובת ל-60 שניות) מקבל הודעה אחרת. return נשמר ל"חזרה לכניסה" רק כשהוא עובר את המגן.
import { useState } from 'react';
import { Link, useSearchParams } from 'react-router';
import { requestPasswordReset } from '../lib/auth.ts';
import { backToLoginUrl } from '../lib/safeReturn.ts';
import { T } from '../lib/strings.ts';
import { Input, Label } from '../components/ui/input.tsx';
import { Button } from '../components/ui/button.tsx';
import { IconAlert, IconInbox } from '../components/brand/icons.tsx';
import { AuthCard } from '../components/AuthCard.tsx';

export function ForgotPage() {
  const [qs] = useSearchParams();
  const back = backToLoginUrl(qs.get('return'));
  const [email, setEmail] = useState('');
  const [err, setErr] = useState('');
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);

  return (
    <AuthCard title={T.forgot.title} lead={sent ? undefined : T.forgot.lead} testId="forgot">
      {sent ? (
        <div className="flex flex-col gap-4" role="status" aria-live="polite" data-testid="forgot-sent">
          <p className="m-0 flex items-start gap-3 rounded-md border border-border bg-muted/60 px-3 py-3 text-sm">
            <IconInbox size={20} className="mt-0.5 shrink-0 text-primary" />
            <span>
              <strong className="block font-bold">{T.forgot.sentTitle}</strong>
              {T.forgot.sent}
            </span>
          </p>
          <p className="m-0 text-sm text-muted-foreground">{T.forgot.sentHint}</p>
        </div>
      ) : (
        <form
          className="flex flex-col gap-4"
          noValidate
          onSubmit={async (e) => {
            e.preventDefault();
            setErr('');
            const addr = email.trim();
            if (!addr) return setErr(T.forgot.missing);
            setBusy(true);
            const r = await requestPasswordReset(addr);
            setBusy(false);
            if (r === 'rate_limited') return setErr(T.forgot.rateLimited);
            // sent וגם failed (SMTP/רשת) — אותו כרטיס: לא מגלים אם הכתובת קיימת
            setSent(true);
          }}
        >
          <div className="flex flex-col gap-1.5">
            <Label htmlFor="email">{T.login.email}</Label>
            <Input id="email" type="email" dir="ltr" autoComplete="username" autoFocus value={email} onChange={(e) => setEmail(e.target.value)} />
          </div>
          {err && (
            <p role="alert" className="m-0 flex items-center gap-2 rounded-md border border-error/35 bg-error/[0.07] px-3 py-2 text-sm font-medium text-error" data-testid="forgot-error">
              <IconAlert size={16} />
              {err}
            </p>
          )}
          <Button type="submit" size="lg" className="mt-1 w-full" disabled={busy}>
            {busy ? T.forgot.busy : T.forgot.submit}
          </Button>
        </form>
      )}
      <Link to={back} className="mt-5 block text-center text-sm font-medium text-primary hover:underline" data-testid="back-to-login">
        {T.forgot.back}
      </Link>
    </AuthCard>
  );
}
